
import initialState from "../../store/initialState";


export default function render(state = initialState.render, action) {

  switch (action.type) {
    case 'UPDATE_SHIRT_RENDER':
    case 'UPDATE_RENDER_BY_CONTRASTS':
      return { ...action.render }
    default:
      return state;
  }
}

